import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

class ResetBrandingButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleClick = this.handleClick.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    handleClick() {
        this.setState({modal: false}, () => this.props.onClick());
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {children, ...rest} = this.props;
        return (
            <button {...rest} onClick={this.toggleModal}>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.admin.branding.modals.reset.title} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.admin.branding.modals.reset.body} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.handleClick}>
                            <FormattedMessage {...messages.admin.branding.reset} />
                        </button>
                    </ModalFooter>
                </Modal>
                {children}
            </button>
        );
    }
}

export default ResetBrandingButton;
